<ng-content>
</ng-content>
<ng-template #toolTipMapTemplate>
  <div class="d-block position-relative" style="width: 300px; height: 300px;">
    <sb-map *ngIf="!polygons" [drawing]="false" [mapHeight]="300" [mapWidth]="300" [initialZoom]="initialZoom"
            [areas]="areas" [showSinglePoint]="coordinates" [zoomControl]="false"
            [opacity]="opacity"
            (initialPanReady)="showMap()" [roundedCorners]="true"></sb-map>
    <sb-polygon-edit-map *ngIf="polygons" [readOnly]="true" [nominatim]="false" [mapheight]="300" [mapwidth]="300"
                         [initialZoom]="initialZoom"
                         [polygons]="polygons" [zoomControl]="false" [opacity]="opacity"
                         (initialPanReady)="showMap()" [roundedCorners]="true"></sb-polygon-edit-map>
  </div>
</ng-template>
